export class UserJobListRequest {
    public sessionToken!: string;
    public jobStatus!: string;
    public resultSize: number = 0;
    public resultPage: number = 0;
    public resultCount: number = 0;
}
